"use strict";

import React from "react";
import ReactDOM from "react-dom";
// import { Provider } from "react-redux";
import { createStore } from "redux";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import { bugsnagClient } from "../shared/utils/errorHandling";
import {
  builderIOInit,
  posthogInit,
  posthogStartSessionRecording,
  gtmDataLayerPush,
  fbPixel,
} from "../shared/utils/analytics";

// import "@stripe/stripe-js"; // https://github.com/stripe/stripe-js#ensuring-stripejs-is-available-everywhere - for fraud detection

// ReactDOM.render(
//   <Provider store={store}>
//     <VisitApp />
//   </Provider>,
//   document.getElementById("visits_container")
// );

import "../material-dashboard/assets/scss/material-dashboard-pro-react.css?v=1.4.0";
import "../shared/styles/material-dashboard-overrides.css";

import indexRoutes from "./routes/index.js";

builderIOInit();

posthogInit();
posthogStartSessionRecording();

const hist = createBrowserHistory();
hist.listen((location) => {
  // console.log("location:", location);

  // if (window.dataLayer) {
  //   window.dataLayer = window.dataLayer || [];
  //   window.dataLayer.push({
  //     event: "Pageview",
  //     path: location.pathname
  //     // formLocation: "footer"
  //   });
  // }

  gtmDataLayerPush({
    event: "pageview",
    path: location.pathname,
  });

  fbPixel("PageView");

  // if (window.fbq) {
  //   window.fbq("track", "PageView");
  // }
});

const ErrorBoundary = bugsnagClient.getPlugin("react");

ReactDOM.render(
  <ErrorBoundary>
    <Router history={hist}>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return (
            <Route path={prop.path} component={prop.component} key={key} />
          );
        })}
      </Switch>
    </Router>
  </ErrorBoundary>,
  document.getElementById("visits_container")
);
